module.exports = __webpack_public_path__ + "static/media/trash.f90f5b03.svg";